
import React, { useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import hostlink from '../Hostlink/hostlink';
import * as XLSX from 'xlsx';
import {
    PDFDownloadLink,
    Document,
    Page,
    Text,
    View,
    StyleSheet
} from '@react-pdf/renderer';

const GodwnStk = () => {

    const usershopid = localStorage.getItem('MYPCKARTUSER')
        ? JSON.parse(localStorage.getItem('MYPCKARTUSER'))[0].id
        : '0';

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Sort No Search
    const [sortSearch, setSortSearch] = useState('');

    const today = new Date();

    const [frmdata, setfrmdata] = useState({
        fromdate: "2024-01-01",
        todate: today.toISOString().split('T')[0],
        deptcode: 0,
        status: 0
    });

    const {
        fromdate,
        todate
    } = frmdata;

    const tableRef = useRef(null);

    // =========================================================
    // Load Data
    // =========================================================
    const loaddata = async () => {

        try {

            setLoading(true);

            const billResponse = await axios.get(
                `${hostlink}/PurchaseMasSTKGodwn/${usershopid}`
            );

            setData(billResponse.data);

            console.log("Data Found...");

        } catch (error) {

            console.log("Data Not Found...");
            setData([]);

        } finally {

            setLoading(false);

        }
    };

    // =========================================================
    // Initial Load
    // =========================================================
    useEffect(() => {
        loaddata();
    }, []);

    // =========================================================
    // Sort No Search Filter
    // =========================================================
    const filteredData = useMemo(() => {

        const search = sortSearch.trim().toLowerCase();

        if (!search) {
            return data;
        }

        return data.filter((res) => {

            const sortNo =
                res?.purchaseMas?.sortno ??
                res?.sortno ??
                '';

            return String(sortNo)
                .toLowerCase()
                .includes(search);
        });

    }, [data, sortSearch]);

    // =========================================================
    // Number Format
    // =========================================================
    const formatNumber = (value) => {

        return Number(value || 0).toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

    };

    // =========================================================
    // Summary
    // =========================================================
    const summary = useMemo(() => {

        const totalMtr = filteredData.reduce(
            (total, res) =>
                total + Number(res.stkqty || 0),
            0
        );

        const totalRoll = filteredData.reduce(
            (total, res) =>
                total + Number(res.stkqtyroll || 0),
            0
        );

        const uniqueSorts = new Set(
            filteredData.map(
                res => res?.purchaseMas?.sortno
            )
        ).size;

        return {
            records: filteredData.length,
            uniqueSorts,
            totalMtr,
            totalRoll
        };

    }, [filteredData]);

    // =========================================================
    // Excel Export
    // =========================================================
    const exportToExcel = () => {

        if (!tableRef.current) {
            return;
        }

        const ws = XLSX.utils.table_to_sheet(
            tableRef.current
        );

        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            wb,
            ws,
            'Godown Stock'
        );

        XLSX.writeFile(
            wb,
            'Godown Stock Report.xlsx'
        );
    };

    // =========================================================
    // Clear Search
    // =========================================================
    const clearSearch = () => {
        setSortSearch('');
    };

    return (

        <div
            className="container-fluid py-3"
            style={{
                background: '#f6f8fb',
                minHeight: '100vh'
            }}
        >

            {/* =====================================================
                HEADER
            ====================================================== */}
            <div
                className="card border-0 mb-3"
                style={{
                    borderRadius: '18px',
                    overflow: 'hidden',
                    boxShadow: '0 6px 24px rgba(15,23,42,0.07)'
                }}
            >

                {/* Header */}
                <div
                    style={{
                        background:
                            'linear-gradient(135deg,#0d6efd,#315efb)',
                        padding: '18px 20px',
                        color: '#fff'
                    }}
                >

                    <div
                        className="d-flex justify-content-between align-items-center flex-wrap gap-2"
                    >

                        <div className="d-flex align-items-center">

                            <div
                                className="d-flex align-items-center justify-content-center me-3"
                                style={{
                                    width: '48px',
                                    height: '48px',
                                    borderRadius: '14px',
                                    background:
                                        'rgba(255,255,255,0.18)'
                                }}
                            >
                                <i
                                    className="fa-solid fa-warehouse"
                                    style={{
                                        fontSize: '21px'
                                    }}
                                ></i>
                            </div>

                            <div>

                                <div
                                    style={{
                                        fontSize: '20px',
                                        fontWeight: '700'
                                    }}
                                >
                                    Godown Stock Report
                                </div>

                                <div
                                    style={{
                                        fontSize: '12px',
                                        opacity: 0.85
                                    }}
                                >
                                    Sort-wise closing stock
                                </div>

                            </div>

                        </div>

                        <div
                            className="badge rounded-pill"
                            style={{
                                background:
                                    'rgba(255,255,255,0.16)',
                                padding: '9px 13px',
                                fontSize: '11px'
                            }}
                        >
                            {filteredData.length} Records
                        </div>

                    </div>

                </div>

                {/* =================================================
                    FILTER AREA
                ================================================== */}
                <div className="card-body p-3">

                    <div className="row g-2 align-items-end">

                        {/* SORT NO SEARCH */}
                        <div className="col-12 col-md-5 col-lg-4">

                            <label
                                className="form-label mb-1"
                                style={{
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}
                            >
                                Search Sort No
                            </label>

                            <div className="input-group input-group-sm">

                                <span
                                    className="input-group-text"
                                    style={{
                                        background: '#fff',
                                        borderRadius:
                                            '10px 0 0 10px'
                                    }}
                                >
                                    <i
                                        className="fa-solid fa-magnifying-glass text-primary"
                                    ></i>
                                </span>

                                <input
                                    type="text"
                                    value={sortSearch}
                                    onChange={(e) =>
                                        setSortSearch(
                                            e.target.value
                                        )
                                    }
                                    placeholder="Search Sort No..."
                                    className="form-control"
                                    style={{
                                        borderRadius:
                                            sortSearch
                                                ? '0'
                                                : '0 10px 10px 0'
                                    }}
                                />

                                {sortSearch && (

                                    <button
                                        type="button"
                                        onClick={clearSearch}
                                        className="btn btn-outline-secondary"
                                        style={{
                                            borderRadius:
                                                '0 10px 10px 0'
                                        }}
                                    >
                                        <i className="fa-solid fa-xmark"></i>
                                    </button>

                                )}

                            </div>

                        </div>

                        {/* FROM DATE */}
                        <div className="col-6 col-md-3 col-lg-2">

                            <label
                                className="form-label mb-1"
                                style={{
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}
                            >
                                From Date
                            </label>

                            <input
                                type="date"
                                name="fromdate"
                                value={fromdate}
                                className="form-control form-control-sm"
                                style={{
                                    borderRadius: '10px'
                                }}
                                readOnly
                            />

                        </div>

                        {/* TO DATE */}
                        <div className="col-6 col-md-3 col-lg-2">

                            <label
                                className="form-label mb-1"
                                style={{
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}
                            >
                                To Date
                            </label>

                            <input
                                type="date"
                                name="todate"
                                value={todate}
                                className="form-control form-control-sm"
                                style={{
                                    borderRadius: '10px'
                                }}
                                readOnly
                            />

                        </div>

                        {/* EXPORT BUTTONS */}
                        <div className="col-12 col-md-6 col-lg-4">

                            <div
                                className="d-flex justify-content-md-end gap-2"
                            >

                                <button
                                    onClick={exportToExcel}
                                    className="btn btn-outline-success btn-sm px-3"
                                    style={{
                                        borderRadius: '10px',
                                        fontWeight: '600'
                                    }}
                                >
                                    <i className="fa-solid fa-file-excel me-1"></i>
                                    Excel
                                </button>

                                <PDFDownloadLink
                                    document={
                                        <PDFDocument
                                            data={filteredData}
                                            fromdate={fromdate}
                                            todate={todate}
                                        />
                                    }
                                    fileName="Godown Stock Report.pdf"
                                    style={{
                                        textDecoration: 'none'
                                    }}
                                >

                                    {({ loading }) => (

                                        <button
                                            className="btn btn-outline-danger btn-sm px-3"
                                            style={{
                                                borderRadius: '10px',
                                                fontWeight: '600'
                                            }}
                                        >
                                            <i className="fa-solid fa-file-pdf me-1"></i>

                                            {loading
                                                ? 'Loading'
                                                : 'PDF'}

                                        </button>

                                    )}

                                </PDFDownloadLink>

                            </div>

                        </div>

                    </div>

                </div>

            </div>


            {/* =====================================================
                KPI CARDS
            ====================================================== */}
            <div className="row g-2 mb-3">

                {/* Records */}
                <div className="col-6 col-md-3">

                    <div
                        className="bg-white h-100"
                        style={{
                            borderRadius: '16px',
                            padding: '16px',
                            boxShadow:
                                '0 4px 18px rgba(0,0,0,0.06)',
                            border:
                                '1px solid #edf0f5'
                        }}
                    >

                        <div className="d-flex justify-content-between">

                            <div>

                                <div
                                    className="text-muted"
                                    style={{
                                        fontSize: '11px',
                                        fontWeight: '600',
                                        textTransform:
                                            'uppercase'
                                    }}
                                >
                                    Records
                                </div>

                                <div
                                    className="fw-bold mt-1"
                                    style={{
                                        fontSize: '20px'
                                    }}
                                >
                                    {summary.records}
                                </div>

                            </div>

                            <div
                                className="d-flex align-items-center justify-content-center"
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '12px',
                                    background: '#eef4ff',
                                    color: '#2563eb'
                                }}
                            >
                                <i className="fa-solid fa-list"></i>
                            </div>

                        </div>

                    </div>

                </div>

                {/* Sorts */}
                <div className="col-6 col-md-3">

                    <div
                        className="bg-white h-100"
                        style={{
                            borderRadius: '16px',
                            padding: '16px',
                            boxShadow:
                                '0 4px 18px rgba(0,0,0,0.06)',
                            border:
                                '1px solid #edf0f5'
                        }}
                    >

                        <div className="d-flex justify-content-between">

                            <div>

                                <div
                                    className="text-muted"
                                    style={{
                                        fontSize: '11px',
                                        fontWeight: '600',
                                        textTransform:
                                            'uppercase'
                                    }}
                                >
                                    Sorts
                                </div>

                                <div
                                    className="fw-bold mt-1"
                                    style={{
                                        fontSize: '20px'
                                    }}
                                >
                                    {summary.uniqueSorts}
                                </div>

                            </div>

                            <div
                                className="d-flex align-items-center justify-content-center"
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '12px',
                                    background: '#eefbf3',
                                    color: '#16a34a'
                                }}
                            >
                                <i className="fa-solid fa-tags"></i>
                            </div>

                        </div>

                    </div>

                </div>

                {/* MTR */}
                <div className="col-6 col-md-3">

                    <div
                        className="bg-white h-100"
                        style={{
                            borderRadius: '16px',
                            padding: '16px',
                            boxShadow:
                                '0 4px 18px rgba(0,0,0,0.06)',
                            border:
                                '1px solid #edf0f5'
                        }}
                    >

                        <div className="d-flex justify-content-between">

                            <div>

                                <div
                                    className="text-muted"
                                    style={{
                                        fontSize: '11px',
                                        fontWeight: '600',
                                        textTransform:
                                            'uppercase'
                                    }}
                                >
                                    Cl. Stock Mtr
                                </div>

                                <div
                                    className="fw-bold mt-1"
                                    style={{
                                        fontSize: '20px'
                                    }}
                                >
                                    {formatNumber(
                                        summary.totalMtr
                                    )}
                                </div>

                            </div>

                            <div
                                className="d-flex align-items-center justify-content-center"
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '12px',
                                    background: '#fff7ed',
                                    color: '#ea580c'
                                }}
                            >
                                <i className="fa-solid fa-ruler-horizontal"></i>
                            </div>

                        </div>

                    </div>

                </div>

                {/* ROLL */}
                <div className="col-6 col-md-3">

                    <div
                        className="bg-white h-100"
                        style={{
                            borderRadius: '16px',
                            padding: '16px',
                            boxShadow:
                                '0 4px 18px rgba(0,0,0,0.06)',
                            border:
                                '1px solid #edf0f5'
                        }}
                    >

                        <div className="d-flex justify-content-between">

                            <div>

                                <div
                                    className="text-muted"
                                    style={{
                                        fontSize: '11px',
                                        fontWeight: '600',
                                        textTransform:
                                            'uppercase'
                                    }}
                                >
                                    Cl. Stock Roll
                                </div>

                                <div
                                    className="fw-bold mt-1"
                                    style={{
                                        fontSize: '20px'
                                    }}
                                >
                                    {formatNumber(
                                        summary.totalRoll
                                    )}
                                </div>

                            </div>

                            <div
                                className="d-flex align-items-center justify-content-center"
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '12px',
                                    background: '#f5f3ff',
                                    color: '#7c3aed'
                                }}
                            >
                                <i className="fa-solid fa-scroll"></i>
                            </div>

                        </div>

                    </div>

                </div>

            </div>


            {/* =====================================================
                ACTIVE SEARCH
            ====================================================== */}
            {sortSearch && (

                <div
                    className="bg-white mb-3 px-3 py-2"
                    style={{
                        borderRadius: '12px',
                        border: '1px solid #e9edf3',
                        boxShadow:
                            '0 3px 12px rgba(0,0,0,0.04)'
                    }}
                >

                    <div
                        className="d-flex align-items-center gap-2"
                    >

                        <span
                            className="text-muted"
                            style={{
                                fontSize: '11px',
                                fontWeight: '600'
                            }}
                        >
                            Active Search:
                        </span>

                        <span className="badge bg-primary rounded-pill">
                            Sort No: {sortSearch}
                        </span>

                        <span
                            className="text-muted"
                            style={{
                                fontSize: '11px'
                            }}
                        >
                            {filteredData.length} result(s)
                        </span>

                    </div>

                </div>

            )}


            {/* =====================================================
                TABLE
            ====================================================== */}
            <div
                className="card border-0"
                style={{
                    borderRadius: '18px',
                    overflow: 'hidden',
                    boxShadow:
                        '0 6px 24px rgba(15,23,42,0.07)'
                }}
            >

                <div
                    className="card-header bg-white border-0 d-flex justify-content-between align-items-center"
                    style={{
                        padding: '15px 18px'
                    }}
                >

                    <div>

                        <div
                            className="fw-bold"
                            style={{
                                color: '#1f2937'
                            }}
                        >
                            Godown Stock Details
                        </div>

                        <small className="text-muted">
                            Sort-wise closing stock
                        </small>

                    </div>

                    <div
                        className="badge rounded-pill"
                        style={{
                            background: '#eef4ff',
                            color: '#2563eb',
                            padding: '8px 12px'
                        }}
                    >
                        {filteredData.length} rows
                    </div>

                </div>


                <div
                    style={{
                        overflowX: 'auto',
                        maxHeight: '65vh'
                    }}
                >

                    <table
                        className="table table-hover align-middle mb-0"
                        ref={tableRef}
                        style={{
                            minWidth: '650px',
                            fontSize: '13px'
                        }}
                    >

                        <thead
                            style={{
                                position: 'sticky',
                                top: 0,
                                zIndex: 5,
                                background: '#f1f5f9'
                            }}
                        >

                            <tr>

                                <th
                                    className="text-start"
                                    style={{
                                        padding: '12px 14px'
                                    }}
                                >
                                    Sort No
                                </th>

                                <th
                                    className="text-end"
                                    style={{
                                        padding: '12px 14px'
                                    }}
                                >
                                    Cl. Stock Mtr
                                </th>

                                <th
                                    className="text-end"
                                    style={{
                                        padding: '12px 14px'
                                    }}
                                >
                                    Cl. Stock Roll
                                </th>

                            </tr>

                        </thead>


                        <tbody>

                            {loading ? (

                                <tr>

                                    <td
                                        colSpan="3"
                                        className="text-center"
                                        style={{
                                            padding: '50px'
                                        }}
                                    >

                                        <div
                                            className="spinner-border text-primary"
                                            role="status"
                                        ></div>

                                        <div
                                            className="text-muted mt-2"
                                            style={{
                                                fontSize: '12px'
                                            }}
                                        >
                                            Loading godown stock...
                                        </div>

                                    </td>

                                </tr>

                            ) : filteredData.length === 0 ? (

                                <tr>

                                    <td
                                        colSpan="3"
                                        className="text-center"
                                        style={{
                                            padding: '60px 20px'
                                        }}
                                    >

                                        <div
                                            className="d-flex align-items-center justify-content-center mx-auto mb-3"
                                            style={{
                                                width: '58px',
                                                height: '58px',
                                                borderRadius: '18px',
                                                background: '#f1f5f9',
                                                color: '#94a3b8'
                                            }}
                                        >
                                            <i
                                                className="fa-solid fa-box-open"
                                                style={{
                                                    fontSize: '24px'
                                                }}
                                            ></i>
                                        </div>

                                        <div className="fw-bold text-dark">
                                            No stock found
                                        </div>

                                        <div
                                            className="text-muted mt-1"
                                            style={{
                                                fontSize: '12px'
                                            }}
                                        >
                                            Try another Sort No.
                                        </div>

                                    </td>

                                </tr>

                            ) : (

                                filteredData.map((res, index) => (

                                    <tr key={index}>

                                        <td
                                            className="text-start fw-semibold"
                                            style={{
                                                padding: '11px 14px',
                                                color: '#2563eb'
                                            }}
                                        >
                                            {res?.purchaseMas?.sortno}
                                        </td>

                                        <td
                                            className="text-end"
                                            style={{
                                                padding: '11px 14px'
                                            }}
                                        >
                                            {formatNumber(
                                                res.stkqty
                                            )}
                                        </td>

                                        <td
                                            className="text-end"
                                            style={{
                                                padding: '11px 14px'
                                            }}
                                        >
                                            {formatNumber(
                                                res.stkqtyroll
                                            )}
                                        </td>

                                    </tr>

                                ))

                            )}

                        </tbody>


                        {!loading && filteredData.length > 0 && (

                            <tfoot>

                                <tr
                                    style={{
                                        position: 'sticky',
                                        bottom: 0,
                                        zIndex: 4,
                                        background: '#eaf2ff',
                                        borderTop:
                                            '2px solid #cbd5e1'
                                    }}
                                >

                                    <td
                                        className="text-end fw-bold"
                                        style={{
                                            padding: '13px 14px'
                                        }}
                                    >
                                        Total :
                                    </td>

                                    <td
                                        className="text-end fw-bold"
                                        style={{
                                            padding: '13px 14px'
                                        }}
                                    >
                                        {formatNumber(
                                            summary.totalMtr
                                        )}
                                    </td>

                                    <td
                                        className="text-end fw-bold"
                                        style={{
                                            padding: '13px 14px'
                                        }}
                                    >
                                        {formatNumber(
                                            summary.totalRoll
                                        )}
                                    </td>

                                </tr>

                            </tfoot>

                        )}

                    </table>

                </div>

            </div>

        </div>
    );
};


// =============================================================
// PDF DOCUMENT
// =============================================================
const PDFDocument = ({
    data,
    fromdate,
    todate
}) => {

    const totalMtr = data.reduce(
        (total, res) =>
            total + Number(res.stkqty || 0),
        0
    );

    const totalRoll = data.reduce(
        (total, res) =>
            total + Number(res.stkqtyroll || 0),
        0
    );

    const formatNumber = (value) =>
        Number(value || 0).toFixed(2);

    return (

        <Document>

            <Page
                orientation="landscape"
                size="A4"
                style={styles.container}
            >

                <Text style={styles.title}>
                    Godown Stock Report
                </Text>

                <Text style={styles.subTitle}>
                    From : {fromdate} To : {todate}
                </Text>

                <View style={styles.table}>

                    {/* HEADER */}
                    <View style={styles.tableRow}>

                        <Text style={styles.headerCell}>
                            Sort No
                        </Text>

                        <Text style={styles.headerCell}>
                            Cl. Stock Mtr
                        </Text>

                        <Text style={styles.headerCell}>
                            Cl. Stock Roll
                        </Text>

                    </View>

                    {/* DATA */}
                    {data.map((res, index) => (

                        <View
                            key={index}
                            style={styles.tableRow}
                        >

                            <Text style={styles.cell}>
                                {res?.purchaseMas?.sortno}
                            </Text>

                            <Text style={styles.cell}>
                                {formatNumber(res.stkqty)}
                            </Text>

                            <Text style={styles.cell}>
                                {formatNumber(res.stkqtyroll)}
                            </Text>

                        </View>

                    ))}

                    {/* TOTAL */}
                    <View style={styles.totalRow}>

                        <Text style={styles.totalCell}>
                            Total :
                        </Text>

                        <Text style={styles.totalCell}>
                            {formatNumber(totalMtr)}
                        </Text>

                        <Text style={styles.totalCell}>
                            {formatNumber(totalRoll)}
                        </Text>

                    </View>

                </View>

            </Page>

        </Document>
    );
};


// =============================================================
// PDF STYLES
// =============================================================
const styles = StyleSheet.create({

    container: {
        padding: 20
    },

    title: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 6,
        textAlign: 'center'
    },

    subTitle: {
        fontSize: 9,
        marginBottom: 15,
        textAlign: 'center'
    },

    table: {
        display: 'table',
        width: '100%',
        borderWidth: 1,
        borderColor: '#444'
    },

    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderColor: '#999'
    },

    headerCell: {
        fontSize: 8,
        fontWeight: 'bold',
        padding: 5,
        flex: 1,
        textAlign: 'center',
        borderRightWidth: 1,
        borderColor: '#999'
    },

    cell: {
        fontSize: 8,
        padding: 5,
        flex: 1,
        textAlign: 'center',
        borderRightWidth: 1,
        borderColor: '#ddd'
    },

    totalRow: {
        flexDirection: 'row',
        backgroundColor: '#eaf2ff',
        borderTopWidth: 1,
        borderColor: '#555'
    },

    totalCell: {
        fontSize: 8,
        fontWeight: 'bold',
        padding: 5,
        flex: 1,
        textAlign: 'center',
        borderRightWidth: 1,
        borderColor: '#999'
    }

});

export default GodwnStk;

